import { useBlocker } from '@tanstack/react-router';
import { useEffect } from 'react';

export const useConfirmLeavePage = (
  shouldPreventLeaving: boolean,
  message: string,
) => {
  const { proceed, reset, status } = useBlocker({
    disabled: !shouldPreventLeaving,
    enableBeforeUnload: shouldPreventLeaving,
    shouldBlockFn({ current, next }) {
      return shouldPreventLeaving && current.pathname !== next.pathname;
    },
    withResolver: true,
  });

  useEffect(() => {
    /**
     * Custom resolver for the attempt to leave the page by using a router function, i.e.
     * - clicking on a link or
     * - clicking the back button.
     */
    if (status === 'blocked') {
      const confirmed = globalThis.confirm(message);
      if (confirmed) {
        proceed();
      } else {
        reset();
      }
    }
  }, [status, message]);

  return { proceed, reset, status };
};
